<script>
	// Stores
	import MarketGroupSetStore from '@/Stores/Sport/MarketGroupSetStore.js';
	import ClassificationStore from '@/Stores/Racing/ClassificationStore.js';
	import SportClassificationStore from '@/Stores/Sport/SportClassificationStore.js';
	// Components
	import SelectInput from '@/Components/SelectInput.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let sportId;

	let tierId;
	let marketGroupSetId;

	$: usedTiers =
		$SportClassificationStore &&
		$SportClassificationStore
			.pluck('classification.id')
			.toArray()
			.map((i) => i.toString());

	function onAdd() {
		if (!tierId || !marketGroupSetId) return;
		SportClassificationStore.saveClassificationMarketGroupSet(sportId, tierId, marketGroupSetId || null)
			.then(() => {
				notify({
					type: 'success',
					title: 'Tier Added',
					message: '',
					timeout: 3
				});
				tierId = false;
				marketGroupSetId = false;
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to update Tier',
					timeout: 5
				});
			});
	}
</script>

<tr class="border-b-4 border-double cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100">
	<td class="p-4 px-6 border-t">
		<SelectInput className="py-1 w-1/3" name="add_tier" required={true} bind:value={tierId}>
			<option value={false}>Select Tier...</option>
			{#each $ClassificationStore.whereNotIn('id', usedTiers).all() as tier (tier.id)}
				<option value={tier.id}>{tier.name}</option>
			{/each}
		</SelectInput>
	</td>
	<td class="p-4 px-6 border-t">
		<SelectInput className="py-1 w-1/3" name="add_market_group_set" required={true} bind:value={marketGroupSetId}>
			<option value={false} selected>Select Market Group Set...</option>
			{#each $MarketGroupSetStore.all() as mgs (mgs.id)}
				<option value={mgs.id}>{mgs.name}</option>
			{/each}
		</SelectInput>
	</td>
	<td class="w-px px-6 border-t">
		<button on:click={onAdd} class="btn btn-black">Add</button>
	</td>
</tr>
